export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
]

export const MEDIA_TYPE_OPTIONS = [
  { value: 'image', label: 'Image' },
  { value: 'video', label: 'Video' },
]

export const CARD_TYPES = {
  RECOMMEND_PUJA: 'recommend_puja',
  RECOMMEND_CHADHAVA: 'recommend_chadhava',
} as const

export const RECOMMENDATION_CARD=['recommend_puja','recommend_chadhava']

export const CARD_TYPE_OPTIONS = [
    { value: 'tithi', label: 'Tithi' },
    { value: 'ritual', label: 'Ritual' },
    { value: 'panchang', label: 'Panchang' },
    { value: 'upcoming_tithi', label: 'Upcoming Tithi' },
    { value: 'recommend_puja', label: 'Recommend Puja' },
    { value: 'recommend_chadhava', label: 'Recommend Chadhava' },
]
